import { IAbUseExperiment } from '../../types/redux/abUseExperiments';

const defaultState: IAbUseExperiment[] = [];

export function experimentsReducer(state: IAbUseExperiment[] = defaultState) {
  return state;
}
